module.exports = __webpack_public_path__ + "static/media/lei08.32131e60.jpg";